import { subscriptionService } from '../../../services/Subscriptions'
import { ActionsUnion, ISubscriptionPlanDTO } from '../../../types/index'
import { createAction } from '../helpers'
import * as constants from '../../constants'

export type ISubscriptionActions = ActionsUnion<typeof actionCreators>

export const actionCreators = {
  listSubscriptionPlansRequest: () => createAction(constants.LIST_SUBSCRIPTION_REQUEST),
  listSubscriptionPlansSuccess: (plans: ISubscriptionPlanDTO[]) =>
    createAction(constants.LIST_SUBSCRIPTION_SUCCESS, plans),
  listSubscriptionPlansFail: (error: string) => createAction(constants.LIST_SUBSCRIPTION_FAIL, error)
}

export const listSubscriptionPlans = () => (dispatch: any) => {
  console.log('Plan load')
  const { listSubscriptionPlansRequest, listSubscriptionPlansFail, listSubscriptionPlansSuccess } = actionCreators
  dispatch(listSubscriptionPlansRequest())
  subscriptionService
    .getSubscriptionPlans()
    .then((plans: ISubscriptionPlanDTO[]) => {
      dispatch(listSubscriptionPlansSuccess(plans))
    })
    .catch(error => {
      dispatch(listSubscriptionPlansFail(error))
    })
}



// WEBPACK FOOTER //
// ./src/state/actions/subscriptions/index.ts